/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Intermediary_Format_LabelInputs */



/**
* | output |
* | --- |
* | "Intermediary Format" |
*
* @param {Drastic_Tech_Intermediary_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_intermediary_format_label = /** @type {((inputs?: Drastic_Tech_Intermediary_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Intermediary_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format intermediaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zwischenformat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato intermedio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Промежуточный формат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato Intermediario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中间格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中間形式")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मध्यवर्ती प्रारूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato intermediário")
	return /** @type {LocalizedString} */ ("Intermediary Format")
});